import React, { Component } from 'react';
import { ContainerComponent } from './Container';

class Container extends Component {
  state = {
    hasError: false,
  };

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    return <ContainerComponent hasError={this.state.hasError} />;
  }
}

export { Container };
